import { z } from 'zod'

/** What a later message does to an established commitment. Closed set; a quote is mandatory. */
export const FindingKind = z.enum([
  'counterparty_chase',
  'explicit_pending',
  'reaffirmed',
  'fulfilled',
  'cancelled',
  'delegated',
  'modified',
])

export const OpennessOutput = z.object({
  findings: z.array(
    z.object({
      /** 1-based index of the later message, as listed. */
      message_index: z.number().int(),
      kind: FindingKind,
      /** Verbatim from that message's NEW TEXT. */
      exact_quote: z.string(),
    }),
  ),
})

export type OpennessOutputT = z.infer<typeof OpennessOutput>
export type FindingKindT = z.infer<typeof FindingKind>
